<template>
    <div>
        <section class="blockElement banner Cmp_guide">
            <div class="container" align="center">
                <div class="m-0 banner_text text-center">
                    <h1 class="m-0">News</h1>
                </div>
            </div>
        </section>
        <!--Section-->
        <section class="blockElement announcements customAccordion pt-0 mt-5">
            <div class="container">
                <ul class="gridView">
                    <li class="gridColumn" v-for="list in newslist">
                        <div class="newsElement">
                            <span v-if="list.img != ''"><img class="img-fluid" width="333" height="250" :src="'../../../../static/website/images/'+list.img" alt="news image" title="shoonya-vews-images" /></span>
                            <h3>
                                <a :href="list.link" target="_blank">{{ list.title }}</a>
                            </h3>
                            <a class="dateAllow" href="#">{{ list.date }}</a>
                            <p v-html="list.description"></p>                            
                        </div>
                    </li>
                </ul>
            </div>
            <app-seo></app-seo>
        </section>
    </div>
</template>
<script>
import SEO from "../shared/SEO";
import VueFaqAccordion from "vue-faq-accordion";
import news from "../../../../static/website/json/new-annoucement.js";
export default {
    name: "FPI",
    data() {
        return {
            newslist:news,
            prismRegisterPath: process.env.PRISM_REGISTER,
            knowledgeBasePath: process.env.KNOWLEDGE_BASE,
            researchReportsPath: process.env.RESEARCH_REPORTS,
            liveChatPath: process.env.LIVE_CHAT,
            myItems: [],
        };
    },
    components: {
        VueFaqAccordion,
        appSeo: SEO,
    },
    methods:{},
    mounted() {
        window.scroll(0, 0);
    },
};
</script>



// WEBPACK FOOTER //
// src/components/website/announcements/announcements.vue